import * as React from 'react';
import { Query } from 'react-apollo';
import Modal from 'react-modal';
import { findMatchingRecord } from 'utils/arrayHelpers';
import GROUPS_COUNT_QUERY from 'groups/containers/GroupList/queries/OrgGroupsCountQuery.gql';

import ListBatchActions from 'components/ListSidebar/ListBatchActions';
import ResendUnclaimedGroupsNotificationModal from 'organizations/components/ResendUnclaimedGroupsNotificationModal.tsx';
import EventTracking from 'lib/EventTracking';

import {
  OrgGroupsCountQuery,
  OrgGroupsCountQueryVariables,
  OrgGroupsCountQuery_organizations,
} from 'groups/containers/GroupList/queries/__generated__/OrgGroupsCountQuery';

export type Props = {
  orgUuid: string;
};

type State = {
  resendNotificationsModalOpen: boolean;
};

export default class UnclaimedGroupListBatchActions extends React.Component<Props, State> {
  state: State = {
    resendNotificationsModalOpen: false,
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  mounted: boolean = false;

  trackEvent = (key: string) => {
    const { orgUuid } = this.props;

    EventTracking.trackKey(key, {
      organization_uuid: orgUuid,
    });
  };

  afterResendNotifications = () => {
    this.trackEvent('school_groupList.batch.resendNotifications.sent');
  };

  openResendNotificationsModal = () => {
    this.setState({
      resendNotificationsModalOpen: true,
    });
  };

  closeResendNotificationsModal = () => {
    if (this.mounted) {
      this.setState({
        resendNotificationsModalOpen: false,
      });
    }
  };

  renderResendNotificationsModal(onRequestHide: () => void, groupCount: number) {
    const { orgUuid } = this.props;

    return (
      <ResendUnclaimedGroupsNotificationModal
        orgUuid={orgUuid}
        groupCount={groupCount}
        onRequestHide={onRequestHide}
      />
    );
  }

  render() {
    const { resendNotificationsModalOpen } = this.state;
    const { orgUuid } = this.props;

    return (
      <Query<OrgGroupsCountQuery, OrgGroupsCountQueryVariables>
        query={GROUPS_COUNT_QUERY}
        variables={{
          orgUuid,
          q: '',
        }}>
        {({ data, error }) => {
          if (error || !data) {
            console.error(
              'UnclaimedGroupListBatchActions - could not load organization with unclaimed group count'
            );
          }

          const org =
            data &&
            findMatchingRecord<OrgGroupsCountQuery_organizations>(data.organizations, orgUuid);

          const unclaimedCount = org ? org.unclaimedGroupCount : 0;

          const actions = [
            {
              ['data-test']: 'notifyClassOwners',
              title: 'Notify class owners',
              onClick: this.openResendNotificationsModal,
              subtext:
                'All owners of unclaimed classes will receive an email to claim their classes.',
              disabled: unclaimedCount === 0,
              tooltip: 'Unavailable because there are no unclaimed classes',
            },
          ];

          return (
            <ListBatchActions actions={actions}>
              <Modal isOpen={resendNotificationsModalOpen}>
                {this.renderResendNotificationsModal(
                  this.closeResendNotificationsModal,
                  unclaimedCount
                )}
              </Modal>
            </ListBatchActions>
          );
        }}
      </Query>
    );
  }
}
